
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesTeaser from './components/ServicesTeaser';
import ProjectsCarousel from './components/ProjectsCarousel';
import WhyChooseUs from './components/WhyChooseUs';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://lgconcretepumping.com';

const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  '@id': `${SITE_URL}/#business`,
  name: 'LG Concrete Pumping & Stone LLC',
  url: SITE_URL,
  telephone: '+18286341304',
  email: 'LGconcretepumpingandstone@gmail.com',
  priceRange: '$$',
  image: `${SITE_URL}/favicon.ico`,
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Otto',
    addressRegion: 'NC',
    postalCode: '28763',
    addressCountry: 'US',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 35.0542,
    longitude: -83.3897,
  },
  areaServed: [
    { '@type': 'AdministrativeArea', name: 'Western North Carolina' },
    { '@type': 'AdministrativeArea', name: 'North Georgia' },
    { '@type': 'AdministrativeArea', name: 'Southwest South Carolina' },
  ],
  description:
    'Professional concrete pumping and stone installation services in Otto, NC. Serving Western North Carolina, North GA, and SW South Carolina with 24/7 availability.',
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Concrete & Stone Services',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Concrete Pumping', url: `${SITE_URL}/services/concrete-pumping` } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Stone Installation', url: `${SITE_URL}/services/stone-services` } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Block Filling', url: `${SITE_URL}/services/block-filling` } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Custom Masonry', url: `${SITE_URL}/services/custom-masonry` } },
    ],
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      opens: '00:00',
      closes: '23:59',
    },
  ],
  sameAs: [],
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${SITE_URL}/#website`,
  url: SITE_URL,
  name: 'LG Concrete Pumping & Stone LLC',
  publisher: { '@id': `${SITE_URL}/#business` },
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
  ],
};

const HomePage = () => {
  useEffect(() => {
    const scripts: HTMLScriptElement[] = [];

    [localBusinessSchema, websiteSchema, breadcrumbSchema].forEach((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
      scripts.push(script);
    });

    document.title = 'LG Concrete Pumping & Stone LLC | Expert Concrete Pumping Otto NC';
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', 'LG Concrete Pumping & Stone LLC provides professional concrete pumping and stone services in Otto, NC. Serving Western North Carolina, North GA, and SW South Carolina with 24/7 availability.');
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', SITE_URL);

    return () => {
      scripts.forEach((s) => s.remove());
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <ServicesTeaser />
        <ProjectsCarousel />
        <WhyChooseUs />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
